import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ArrowButton from '../../components/arrowButton';
import CircleArrowButton from '../../components/circleArrowButton';
// import Tag from '../../components/tag';
import WhatWeDoModal from './components/WhatWeDoModal';
import SlogenCarousel from './components/SlogenCarousel';
import { useApplicationForm } from '../../contexts/ApplicationFormContext';
import { projectsData, getLatestNews } from '../../mockData';
// import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import { slogenCardsDataByLang } from './constant';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function Home() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { openApplicationForm } = useApplicationForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [isRecommendedLoaded, setIsRecommendedLoaded] = useState(false);
  const [isCloudLoaded, setIsCloudLoaded] = useState(false);
  const [isCloudFadeInComplete, setIsCloudFadeInComplete] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 833);
  
  // 获取当前语言
  const currentLang = i18n.language || 'zh';
  
  // 根据语言获取标题图片
  const getTitleImage = (lang) => {
    switch(lang) {
      case 'zh':
        return '/image/简体234.png';
      case 'zh_TW':
        return '/image/繁体21.png';
      case 'en':
        return '/image/英文21.png';
      default:
        return '/image/繁体21.png';
    }
  };

  const whatWeDoData = [
    {
      id: 1,
      type: 'education',
      image: '/image/推展教育.png',
      title: t('home.whatWeDo.education.title'),
      subtitle: t('home.whatWeDo.education.subtitle'),
      description: t('home.whatWeDo.education.description'),
      details: [
        t('home.whatWeDo.education.details.item1'),
        t('home.whatWeDo.education.details.item2'),
        t('home.whatWeDo.education.details.item3'),
        t('home.whatWeDo.education.details.item4'),
        t('home.whatWeDo.education.details.item5')
      ]
    },
    {
      id: 2,
      type: 'fertility',
      image: '/image/促进生育.png',
      title: t('home.whatWeDo.fertility.title'),
      subtitle: t('home.whatWeDo.fertility.subtitle'),
      description: t('home.whatWeDo.fertility.description'),
      details: currentLang === 'en' ? [
        // 英文版本：平铺结构
        t('home.whatWeDo.fertility.details.item1'),
        t('home.whatWeDo.fertility.details.item2'),
        t('home.whatWeDo.fertility.details.item3'),
      ] : [
        // 中文版本：嵌套结构
        {
          title: t('home.whatWeDo.fertility.details.clinic.title'),
          items: [
            t('home.whatWeDo.fertility.details.clinic.item1'),
            t('home.whatWeDo.fertility.details.clinic.item2'),
            t('home.whatWeDo.fertility.details.clinic.item3'),
            t('home.whatWeDo.fertility.details.clinic.item4')
          ]
        },
        t('home.whatWeDo.fertility.details.item2'),
        t('home.whatWeDo.fertility.details.item3'),
      ]
    },
    {
      id: 3,
      type: 'poverty',
      image: '/image/纾解贫困.png',
      title: t('home.whatWeDo.poverty.title'),
      subtitle: t('home.whatWeDo.poverty.subtitle'),
      description: t('home.whatWeDo.poverty.description'),
      details: [
        t('home.whatWeDo.poverty.details.item1'),
        t('home.whatWeDo.poverty.details.item2'),
        t('home.whatWeDo.poverty.details.item3'),
        t('home.whatWeDo.poverty.details.item4'),
        t('home.whatWeDo.poverty.details.item5'),
        t('home.whatWeDo.poverty.details.item6')
      ]
    }
  ];

  const handleCardClick = (index) => {
    setCurrentModalIndex(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePrevious = () => {
    setCurrentModalIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    setCurrentModalIndex((prev) => prev + 1);
  };

  // 从 mockData 中获取项目数据
  // 只显示进行中的项目，取前3个
  const inProgressProjects = projectsData.slice(0, 3);
  let heldProjectsData = {
    top: null,
    bottom: []
  };
  if (inProgressProjects.length === 1) {
    heldProjectsData = {
      top: inProgressProjects[0] || null,
      bottom: []
    };
  } else if (inProgressProjects.length === 2) {
    heldProjectsData = {
      top: null,
      bottom: [inProgressProjects[0], inProgressProjects[1]]
    };
  } else {
    heldProjectsData = {
      top: inProgressProjects[0] || null,
      bottom: inProgressProjects.slice(1, 3)
    };
  }

  // 从 mockData 中获取最新新闻数据（取2条）
  const latestNewsData = getLatestNews(2, currentLang);

  // 根据当前语言获取对应的语录数据
  const slogenCardsData = slogenCardsDataByLang[currentLang] || slogenCardsDataByLang.zh;

  const fundingApplicationData = [
    {
      id: 1,
      image: '/image/第一步.png',
      title: t('home.funding.step1.title'),
      description: t('home.funding.step1.description'),
      note: t('home.funding.step1.note')
    },
    {
      id: 2,
      image: '/image/第二步.png',
      title: t('home.funding.step2.title'),
      description: t('home.funding.step2.description'),
      note: ''
    },
    {
      id: 3,
      image: '/image/第三步.png',
      title: t('home.funding.step3.title'),
      description: t('home.funding.step3.description'),
      note: ''
    }
  ];

  // 检测移动端
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 833);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 预加载推荐版背景图和云朵图，加载完成后淡入显示
  useEffect(() => {
    // 预加载推荐版背景图片
    const recommendedImage = new Image();
    
    // 先设置onload，再设置src，这样如果图片已在缓存中，onload会立即触发
    recommendedImage.onload = () => {
      setIsRecommendedLoaded(true);
    };
    recommendedImage.onerror = () => {
      // 如果推荐版加载失败，保持使用压缩版
      console.warn('推荐版背景图加载失败，继续使用压缩版');
    };
    
    // 设置src触发加载（如果已在缓存中，onload会立即触发）
    recommendedImage.src = '/image/首页背景图-推荐.jpg';
    
    // 如果图片已经在缓存中，立即标记为已加载
    if (recommendedImage.complete) {
      setIsRecommendedLoaded(true);
    }
    
    // 预加载云朵图原版
    const cloudImage = new Image();
    cloudImage.onload = () => {
      setIsCloudLoaded(true);
      // 等待淡入动画完成（0.6秒）后，标记淡入完成，开始淡出压缩版
      setTimeout(() => {
        setIsCloudFadeInComplete(true);
      }, 600);
    };
    cloudImage.onerror = () => {
      // 如果原版加载失败，保持使用压缩版
      console.warn('云朵图原版加载失败，继续使用压缩版');
    };
    cloudImage.src = '/image/首页顶部云朵.png';
    
    // 如果图片已经在缓存中，立即标记为已加载
    if (cloudImage.complete) {
      setIsCloudLoaded(true);
      // 等待淡入动画完成（0.6秒）后，标记淡入完成，开始淡出压缩版
      setTimeout(() => {
        setIsCloudFadeInComplete(true);
      }, 600);
    }
    
    // 预加载标题图片（所有语言版本）
    const titleImages = [
      '/image/简体234.png',
      '/image/繁体21.png',
      '/image/英文21.png'
    ];
    
    titleImages.forEach((src) => {
      const titleImage = new Image();
      titleImage.src = src;
    });
  }, []);

  return (
    <div className="home-container">
      <div 
        className="home-hero-background"
        style={{ 
          position: 'relative'
        }}
      >
        {/* 压缩版背景层 - 始终显示，作为底层 */}
        <div 
          className="home-hero-bg-layer home-hero-bg-compressed"
          style={{ 
            backgroundImage: `url(${isMobile ? '/image/移动端首页.png' : '/image/首页背景图-已压缩.jpg'})`,
            ...(isMobile && {
              backgroundSize: 'contain',
              backgroundPosition: 'center top'
            })
          }}
        />
        {/* 推荐版背景层 - 始终存在，加载完成后淡入显示，覆盖压缩版 */}
        <div 
          className="home-hero-bg-layer home-hero-bg-recommended"
          style={{ 
            backgroundImage: `url(${isMobile ? '/image/移动端首页.png' : '/image/首页背景图-推荐.jpg'})`,
            opacity: isMobile ? 1 : (isRecommendedLoaded ? 1 : 0),
            transition: isMobile ? 'none' : (isRecommendedLoaded ? 'opacity 0.6s ease-in-out' : 'none'),
            ...(isMobile && {
              backgroundSize: 'contain',
              backgroundPosition: 'center top'
            })
          }}
        />
        <div className="hero-text-container">
          <div 
            className="section-title"
            style={{ 
              backgroundImage: `url(${getTitleImage(currentLang)})`
            }}
          >
            {t('home.hero.title')}
          </div>
          {/* <div className="section-content">
            <p>
            {t('home.hero.description')}</p>
          </div> */}
        </div>
        <div className="home-container-image">
          {/* 压缩版云朵图 - 原版淡入完成后逐渐淡出 */}
          <div 
            className="home-cloud-layer home-cloud-compressed"
            style={{
              backgroundImage: 'url(/image/首页顶部云朵-已压缩.png)',
              opacity: isCloudFadeInComplete ? 0 : 1,
              transition: isCloudFadeInComplete ? 'opacity 0.6s ease-in-out' : 'none'
            }}
          />
          {/* 原版云朵图 - 始终存在，加载完成后淡入显示，覆盖压缩版 */}
          <div 
            className="home-cloud-layer home-cloud-original"
            style={{
              backgroundImage: 'url(/image/首页顶部云朵.png)',
              opacity: isCloudLoaded ? 1 : 0,
              transition: isCloudLoaded ? 'opacity 0.6s ease-in-out' : 'none'
            }}
          />
        </div>
      </div>
      <div className="section-container purpose-section" style={{ marginTop: '-70px' }}>
        <div className="section-header">
          <div className="section-title2" style={{ marginBottom: '20px' }}>{t('home.purpose.title')}
          <span className="section-title2-dot"></span>
          </div>
        </div>
        <div className="what-we-do-container">
          {whatWeDoData.map((item, index) => (
            <div 
              key={item.id} 
              className="what-we-do-card"
              onClick={() => handleCardClick(index)}
            >
              <div className="what-we-do-image">
                <img src={item.image} alt={item.title} loading="lazy" />
              </div>
              <h3 className="what-we-do-title">{item.title}</h3>
              <p className="what-we-do-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      <WhatWeDoModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        data={whatWeDoData[currentModalIndex]}
        currentIndex={currentModalIndex}
        totalCount={whatWeDoData.length}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />
      <div className="section-container">
        <div className="section-header">
          <div className="section-title2">{t('home.projects.title')}
          <span className="section-title2-dot"></span>
          </div>
          <ArrowButton text={t('home.projects.more')} size="large" onClick={() => {
            navigate('/projects');
          }}></ArrowButton>
        </div>
        <div className="held-projects-card">
          {heldProjectsData.top && (
            <div className="held-projects-top">
              <div 
                className="held-projects-item"
                onClick={() => navigate(`/projects/${heldProjectsData.top.id}`)}
                style={{ cursor: 'pointer' }}
              >
                <div 
                  className="held-projects-item-bg"
                  style={{ backgroundImage: `url(${heldProjectsData.top.image})` }}
                />
                <div className="held-projects-content">
                  <div className="held-projects-title">{heldProjectsData.top.title[currentLang]}</div>
                  <CircleArrowButton />
                </div>
              </div>
            </div>
          )}
          <div className="held-projects-bottom">
            {heldProjectsData.bottom.map((item) => (
              <div 
                key={item.id}
                className="held-projects-item"
                onClick={() => navigate(`/projects/${item.id}`)}
                style={{ cursor: 'pointer' }}
              >
                <div 
                  className="held-projects-item-bg"
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className="held-projects-content">
                  <div className="held-projects-title">{item.title[currentLang]}</div>
                  <CircleArrowButton />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {latestNewsData.length > 0 ? (
      <div className="section-container">
      <div className="section-header">
        <div className="section-title2">{t('home.news.title')}
          <span className="section-title2-dot"></span>
          </div>
          <ArrowButton text={t('home.news.more')} size="large" onClick={() => {
            navigate('/news');
          }}></ArrowButton>
        </div>
        <div className="latest-news-container">
          {latestNewsData.map((item) => (
            <div 
              key={item.id} 
              className="latest-news-card"
              onClick={() => navigate(`/news/${item.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="latest-news-text">
                {/* <Tag>{item.tag}</Tag> */}
                <div>
                <h3 className="latest-news-title">{item.title}</h3>
                <p className="latest-news-description">{item.description}</p>
                </div>
                <p className="latest-news-data">{item.date}</p>
              </div>
              <div className="latest-news-image-wrapper">
                <img src={item.image} alt={item.title} className="latest-news-image" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
      ) : <div></div>}
      <div className="section-container">
       <div className="section-header">
        <div className="section-title2">{t('home.slogen.title')}
          <span className="section-title2-dot"></span>
          </div>
        </div>
        <SlogenCarousel items={slogenCardsData} autoPlayInterval={6000} autoPlay={true} />
      </div>
      <div className="section-container section-container-end">
      <div className="section-header">
        <div className="section-title2">{t('home.funding.title')}
          <span className="section-title2-dot"></span>
          </div>
          <ArrowButton text={t('home.funding.more')} size="large" onClick={() => {
            navigate('/apply-info');
          }}></ArrowButton>
        </div>
        <div className="funding-application-container">
          {fundingApplicationData.map((item) => (
            <div key={item.id} className="funding-application-card">
              <div className="funding-application-border-glow"></div>
              <div className="funding-application-content-glow"></div>
              <div className="funding-application-image" style={{ backgroundImage: `url(${item.image})` }}></div>
              <h3 className="funding-application-title">{item.title}</h3>
              <p 
                className="funding-application-description"
                dangerouslySetInnerHTML={{ 
                  __html: item.description.replace(/\s{2,}/g, '<br/>') 
                }}
              />
              {/* <p className="funding-application-note">{item.note}</p> */}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
          <ArrowButton text={t('home.funding.applyNow')} variant="special" size="large" onClick={openApplicationForm}></ArrowButton>
        </div>
      </div>
      <div className="section-container" style={{ boxShadow: '0px 4px 27.1px 0px #EFF7FF82' }}>
        <div className="contact-card">
          <div className="contact-item">
              <div className="contact-title">{t('home.contact.title')}<span className="section-title2-dot"></span></div>
              
            <div className="contact-content-row">{t('home.contact.description')}</div>
            <div className="contact-content-row">{t('home.contact.description2')}</div>
            {/* <div className="contact-note">{t('home.contact.hours')}</div> */}
          </div>
          <div className="contact-item">
            {/* <div className="contact-info-row">
              <div className="contact-icon-placeholder" style={{ backgroundImage: 'url(/image/电话.png)' }}></div>
              <div className="contact-label">{t('home.contact.phone')}</div>
            </div>
            <div className="contact-content">0632-23-45676</div> */}
          </div>
          <div className="contact-item">
            <div className="contact-info-row">
              <div className="contact-icon-placeholder" style={{ backgroundImage: 'url(/image/Email.png)' }}></div>
              <div className="contact-label">{t('home.contact.email')}</div>
            </div>
            
              <a href={`mailto:${t('home.contact.email.link')}`}>
                <div className="contact-content contact-email" >
                {t('home.contact.email.link')}
                </div>
              </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;

